import React from 'react';

import scss from './ActionsWrapper.module.scss';

function ActionsWrapper({ children }) {
  return <div className={scss.actionsWrapper}>{children}</div>;
}

export default ActionsWrapper;
